<template>
  <div :class="[classes.wrapper]" ref="wrapper">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, Ref, watchEffect } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { useBrand } from "../hooks/useBrand";

import {
  useDimensionSync,
  Dimensions
} from "@fresh8/vue-utils/src/dimensionSync";
import { provideAdSize } from "../hooks/useAdSize";

const useStyles = createUseStyles({
  wrapper: {
    width: props => props?.width || "",
    height: props => props?.height || "",
    backgroundColor: props => props.backgroundColor || "",
    borderRadius: props => props.borderRadius || 0,
    padding: "0 16px",
    boxSizing: "border-box",
    overflow: "hidden",
    display: "grid",
    gridTemplateRows: "44px 174px 40px",
    gridTemplateColumns: "1fr",
    justifyContent: "space-between",
    alignItems: "center",
    maxHeight: "258px",
    "@media screen and (max-width: 400px)": {
      padding: "0 12px",
      gridTemplateRows: "44px 174px 32px"
    }
  }
});

export default defineComponent({
  setup() {
    const wrapper = ref(null);
    const { adTagSize, responsive, adTemplateBranding } = useBrand();
    const { dimensions } = useDimensionSync(wrapper);

    provideAdSize((dimensions as unknown) as Ref<Dimensions>);

    watchEffect(onInvalidate => {
      let updateParentToken;
      function updateParent() {
        window.parent.postMessage(
          { type: "f8_size", contentHeight: dimensions.value.height },
          "*"
        );
        updateParentToken = setTimeout(updateParent, 100);
      }
      updateParent();
      onInvalidate(() => updateParentToken && clearTimeout(updateParentToken));
    });

    const size = computed(() => {
      if (responsive.value) {
        return { width: "100%" };
      }
      return {
        width: adTagSize.value?.width,
        height: adTagSize.value?.height
      };
    });

    const reativeStyles = computed(() => ({
      ...size.value,
      ...adTemplateBranding.value
    }));

    const classesRef = useStyles(reativeStyles);

    return {
      classes: classesRef.value,
      wrapper
    };
  }
});
</script>

<style></style>
